var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"stk-icon is-button",attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_c('i',{class:_vm.icon})])
}
var staticRenderFns = []

export { render, staticRenderFns }